exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-private-pages-generate-link-js": () => import("./../../../src/pages/private-pages/generate-link.js" /* webpackChunkName: "component---src-pages-private-pages-generate-link-js" */),
  "component---src-pages-private-pages-guest-upload-js": () => import("./../../../src/pages/private-pages/guest-upload.js" /* webpackChunkName: "component---src-pages-private-pages-guest-upload-js" */)
}

